class ResponsiveTabs {
    constructor() {
      this.tabs = document.querySelectorAll('.responsive-tabs__tab');
      this.contents = document.querySelectorAll('.responsive-tabs__content');
      this.customSelectWrapper = document.querySelector('.responsive-tabs__custom');
      this.customSelectTrigger = document.querySelector('.responsive-tabs__trigger');
      this.customSelectOptions = document.querySelectorAll('.responsive-tabs__custom-option');
  
      if (this.tabs.length && this.contents.length) {
        this.initTabs();
      }

      if (this.customSelectWrapper && this.customSelectTrigger && this.customSelectOptions.length) {
        this.initCustomSelect();
      }
      
      this.bindEvents();
    }
  
    initTabs() {
      this.tabs.forEach(tab => {
        tab.addEventListener('click', () => {
          this.deactivateTabs();
          this.activateTab(tab);
          this.showContent(tab.dataset.target);
        });
      });
  
      // Set initial active tab and content
      const initialActiveTab = this.tabs[0];
      this.activateTab(initialActiveTab);
      this.showContent(initialActiveTab.dataset.target);
    }
  
    initCustomSelect() {
      this.customSelectTrigger.addEventListener('click', () => {
        this.customSelectWrapper.classList.toggle('responsive-tabs__custom--active');
      });
  
      this.customSelectOptions.forEach(option => {
        option.addEventListener('click', () => {
          this.deactivateTabs();
          const correspondingTab = document.querySelector(`.responsive-tabs__tab[data-target="${option.dataset.target}"]`);
          this.activateTab(correspondingTab);
          this.customSelectTrigger.textContent = option.textContent;
          this.customSelectWrapper.classList.remove('responsive-tabs__custom--active');
          this.showContent(option.dataset.target);
        });
      });
    }
  
    bindEvents() {
      window.addEventListener('resize', this.handleResize.bind(this));
      this.handleResize();
    }
  
    deactivateTabs() {
      this.tabs.forEach(tab => tab.classList.remove('responsive-tabs__tab--active'));
      this.contents.forEach(content => content.classList.remove('responsive-tabs__content--active'));
    }
  
    activateTab(tab) {
      tab.classList.add('responsive-tabs__tab--active');
    }
  
    showContent(id) {
      const content = document.getElementById(id);
      if (content) {
        content.classList.add('responsive-tabs__content--active');
      }
    }
  
    handleResize() {
      if (window.innerWidth <= 880) {
        const activeContent = document.querySelector('.responsive-tabs__content--active');
        if (activeContent) {
          this.customSelectTrigger.textContent = document.querySelector(`.responsive-tabs__custom-option[data-target=${activeContent.id}]`).textContent;
        }
      } else {
        const activeTab = document.querySelector('.responsive-tabs__tab--active');
        if (activeTab) {
          this.customSelectTrigger.textContent = activeTab.textContent;
        }
      }
    }
  }
  
  document.addEventListener('DOMContentLoaded', () => {
    new ResponsiveTabs();
  });
  